'use strict';

angular.module('transport.changeRequests.studentPickerWithDiaryEvents', [
    'transport.changeRequests.transportChangeRequestAdd',
    'transport.services.changeRequestService',
    'transport.services.transportTimetablesService',
    'shared.components.sbAutoComplete',
    'shared.components.sbStackedDate',
    'shared.components.sbModalHeader',
    'shared.services.portalChangeRequestService',
])
    .component('studentPickerWithDiaryEvents', {
        templateUrl: '/Scripts/app/transport/changeRequests/student-picker-with-diary-events.template.html',
        bindings: {
            modalInstance: '<',
            resolve: '<',
        },
        controller: [
            '$uibModal',
            'changeRequestService',
            'portalChangeRequestService',
            'transportTimetablesService',
            'simpleAlertService',
            function studentPickerWithDiaryEvents($uibModal, changeRequestService, portalChangeRequestService, transportTimetablesService,  simpleAlertService )
            {

                this.$onInit = function () {
                    this.pupil = { event: [] };
                }.bind(this);

                this.showAddChangeRequest = function (calendarEventItem)
                {
                    this.resolve.onChangeRequestModalOpen({changeRequest: { calendarEventTransportAttendeeId: calendarEventItem.id }});
                }.bind(this);

                this.viewReviewChangeRequest = function (transportAttendeeId)
                {
                    this.resolve.onChangeRequestViewModalOpen({changeRequest: { calendarEventTransportAttendeeId: transportAttendeeId }});
                }.bind(this);

                this.getPupils = changeRequestService.GetTransportDiaryEventsByPupilName;

                this.onSelectStudent = function ($item) {
                    this.pupil = $item
                }.bind(this);

                this.close = function () {
                    this.modalInstance.close();
                }.bind(this);
            }
        ]
    });
